  var win = window;
  var doc = document;
  var TOUCH_START = 'ontouchstart' in win ? 'touchstart' : 'mousedown';
  var TOUCH_MOVE = 'ontouchmove' in win ? 'touchmove' : 'mousemove';
  var TOUCH_END = 'ontouchend' in win ? 'touchend' : 'mouseup';
  var emptyFn = function () {};

/***************** core **************/


  // 判断是否为类数组或者数组
  var obj = {};
  var isArray = function (item) {
    return obj.toString.call(item) === '[object Array]' ||
        (item.length >= 0 && typeof item[0] !== 'undefined' &&
            typeof item[item.length - 1] !== 'undefined');
  };

  var each = function (collection, callback, scope) {
    for (var i = 0, iLen = collection.length; i < iLen; i++) {
      callback.call(scope || collection[i], i, collection[i]);
    }
  };

  var extend = function () {
    var o = {};
    var obj;
    var key;
    for (var i = 0, iLen = arguments.length; i < iLen; i++) {
      obj = arguments[i];
      for (key in obj) {
        o[key] = obj[key];
      }
    }
    return o;
  };

/***************** selecter query **************/

  // 获取dom列表
  var query = function (selector, context) {
    context = context || doc;

    if (selector === window || selector === document || (selector && typeof selector.nodeType != 'undefined')) {
      return [selector];
    }

    if (typeof selector === 'string') {
      return context.querySelectorAll(selector);
    } else if (isArray(selector)) {
      return selector;
    } else {
      return [selector];
    }
  };

/***************** dom operation **************/

  // 插入dom元素
  var append = function (elm, appendElm) {
    elm.appendChild(appendElm);
  };

  var html = function (selector, content) {
    var elms = query(selector);
    each(elms, function () {
      this.innerHTML = content;
    });
  };

/***************** css operation **************/

  var hasClass = function (selector, className) {
    var elm = query(selector)[0];
    return hasClassSingle(elm, className);
  };

  var addClass = function (selector, className) {
    var elms = query(selector);
    each(elms, function () {
      addClassSingle(this, className);
    });
  };

  var removeClass = function (selector, className) {
    var elms = query(selector);
    each(elms, function () {
      removeClassSingle(this, className);
    });
  };

  var hasClassSingle = function (elm, className) {
    var fullClassName = ' ' + elm.className + ' ';
    return fullClassName.indexOf(' ' + className + ' ') >= 0;
  };

  var addClassSingle = function (elm, className) {
    if (!hasClassSingle(elm, className)) {
      elm.className = elm.className + ' ' + className;
    }
  };

  var removeClassSingle = function (elm, className) {
    var re = new RegExp('(^|\\s)' + className + '(\\s|$)', 'g');
    if (hasClassSingle(elm, className)) {
      elm.className = elm.className.replace(re, ' ');
    }
  };

  var css = function (selector, opts) {
    var elms = query(selector);
    each(elms, function () {
      cssSingle(this, opts);
    });
  };

  var cssSingle = function (elm, opts) {
    for (var key in opts) {
      elm.style[key] = opts[key];
    }
  };

/***************** events **************/

  // 注册一个事件
  var on = function (selector, type, callback, opts, forControllBar) {
    var elms = query(selector);

    each(elms, function () {
      if (forControllBar) {
        oneControll(this, type, callback, opts);
      } else {
        one(this, type, callback, opts);
      }
    });
  };

  // 为一个dom元素注册一个事件
  var one = function (elm, type, callback, opts) {
    opts = opts || {};
    elm.addEventListener(type, function (e) {

      var delegateElm;
      if (typeof opts.delegate !== 'undefined') {
        delegateElm = getDelegate(elm, opts.delegate, e.target);
      }

      // 没找到匹配的代理元素，不执行下面的事件
      if (typeof opts.delegate !== 'undefined' && typeof delegateElm === 'undefined') {
        return;
      }

      var scope = opts.scope || delegateElm || elm;

      callback.call(scope, e, delegateElm || elm);
    }, false);
  };

  // 兼容ios端滑动事件冒泡
  var oneControll = function (elm, type, callback, opts) {
    opts = opts || {};
    elm.addEventListener(type, function (e) {
      e.preventDefault();
      var delegateElm;
      if (typeof opts.delegate !== 'undefined') {
        delegateElm = getDelegate(elm, opts.delegate, e.target);
      }

      // 没找到匹配的代理元素，不执行下面的事件
      if (typeof opts.delegate !== 'undefined' && typeof delegateElm === 'undefined') {
        return;
      }

      var scope = opts.scope || delegateElm || elm;

      callback.call(scope, e, delegateElm || elm);
    }, false);
  };

  // 获取正确的代理元素
  var getDelegate = function (elm, delegate, target) {
    var matchs;
    var i;

    if (typeof delegate !== 'string') {
      matchs = [delegate];
    } else {
      matchs = elm.querySelectorAll(delegate);
    }

    var iLen = matchs.length;
    while (elm !== target) {
      for (i = 0; i < iLen; i++) {
        if (target === matchs[i]) {
          return target;
        }
      }
      target = target.parentNode;
    }
  };

  // 轻触屏幕
  var tap = function (elm, callback, opts) {
    opts = opts || {};
    var duration = opts.duration || 0;
    var fixDistance = opts.fixDistance || 10;
    var time;
    var pageX;
    var pageY;

    on(elm, TOUCH_START, function (e, target) {

      if (typeof opts.hover === 'string') {
        addClass(target, opts.hover);
      }

      time = new Date().valueOf();
      pageX = getEventPageXY(e, 'x');
      pageY = getEventPageXY(e, 'y');
    }, opts);

    on(elm, TOUCH_END, function (e, target) {
      var result = true;
      var endTime = new Date().valueOf();
      var endPageX = getEventPageXY(e, 'x', true);
      var endPageY = getEventPageXY(e, 'y', true);

      if (typeof opts.hover === 'string') {
        removeClass(target, opts.hover);
      }

      if (endTime - time > duration &&
          Math.abs(endPageX - pageX) < fixDistance &&
          Math.abs(endPageY - pageY) < fixDistance) {
        result = callback.call(this, e, target, endPageX, endPageY);
      }

      if (result === false) {
        e.preventDefault();
        e.stopPropagation();
      }

    }, opts);
  };

  // 获取触摸的位置
  var getEventPageXY = function (e, xy, isEnd) {
    e = e || window.event;
    xy = xy === 'x' ? 'pageX' : 'pageY';
    isEnd = typeof isEnd === 'undefined' ? false : true;
    var useTouch = 'ontouchstart' in win;

    if (!useTouch) {
      return e[xy];
    } else if (isEnd) {
      return e.changedTouches[0][xy];
    } else {
      return e.touches[0][xy];
    }

  };

  // 滑动
  var swip = function (elm, startCallback, movCallback, endCallback, opts) {
    opts = opts || {};
    var beginX;
    var beginY;
    var endX;
    var endY;
    var actualDirect = 'unknown';
    startCallback = startCallback || emptyFn;
    movCallback = movCallback || emptyFn;
    endCallback = endCallback || emptyFn;

    on(elm, TOUCH_START, function (e) {
      actualDirect = 'unknown';
      beginX = getEventPageXY(e, 'x');
      beginY = getEventPageXY(e, 'y');
      startCallback.call(this, beginX, beginY);
    }, opts);

    on(elm, TOUCH_MOVE, function (e) {
      var movX = getEventPageXY(e, 'x');
      var movY = getEventPageXY(e, 'y');
      var result;

      // 计算一个真实的滑动方向
      if (actualDirect === 'unknown') {

        if (Math.abs(movX - beginX) > Math.abs(movY - beginY)) {
          actualDirect = 'horizontal';
        } else {
          actualDirect = 'vertical';
        }
      }

      // @todo 这块逻辑有点太复杂了，回头需要考虑如何简化。
      // 考虑的应用场景太多，给搞复杂了。。。
      if (typeof opts.direct !== 'undefined') {

        if (opts.direct === 'horizontal') {
          result = movCallback.call(this, beginX, movX, actualDirect);
        } else {
          result = movCallback.call(this, beginY, movY, actualDirect);
        }

      } else {

        if (actualDirect === 'horizontal') {
          result = movCallback.call(this, beginX, movX, actualDirect);
        } else {
          result = movCallback.call(this, beginY, movY, actualDirect);
        }
      }

      if (result === false) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, opts);

    on(elm, TOUCH_END, function (e) {
      endY = getEventPageXY(e, 'y', true);
      endX = getEventPageXY(e, 'x', true);

      if (typeof opts.direct !== 'undefined') {

        if (opts.direct === 'horizontal') {
          endCallback.call(this, beginX, endX, actualDirect);
        } else {
          endCallback.call(this, beginY, endY, actualDirect);
        }
      } else {

        if (actualDirect === 'horizontal') {
          endCallback.call(this, beginX, endX, actualDirect);
        } else {
          endCallback.call(this, beginY, endY, actualDirect);
        }
      }

    }, opts);

  };

  var controllSwip = function (elm, startCallback, movCallback, endCallback, opts) {
    opts = opts || {};
    var beginX;
    var beginY;
    var endX;
    var endY;
    var actualDirect = 'unknown';
    startCallback = startCallback || emptyFn;
    movCallback = movCallback || emptyFn;
    endCallback = endCallback || emptyFn;

    on(elm, TOUCH_START, function (e) {
      actualDirect = 'unknown';
      beginX = getEventPageXY(e, 'x');
      beginY = getEventPageXY(e, 'y');
      startCallback.call(this, beginX, beginY);
    }, opts, true);

    on(elm, TOUCH_MOVE, function (e) {
      var movX = getEventPageXY(e, 'x');
      var movY = getEventPageXY(e, 'y');
      var result;

      // 计算一个真实的滑动方向
      if (actualDirect === 'unknown') {

        if (Math.abs(movX - beginX) > Math.abs(movY - beginY)) {
          actualDirect = 'horizontal';
        } else {
          actualDirect = 'vertical';
        }
      }

      // @todo 这块逻辑有点太复杂了，回头需要考虑如何简化。
      // 考虑的应用场景太多，给搞复杂了。。。
      if (typeof opts.direct !== 'undefined') {

        if (opts.direct === 'horizontal') {
          result = movCallback.call(this, beginX, movX, actualDirect);
        } else {
          result = movCallback.call(this, beginY, movY, actualDirect);
        }

      } else {

        if (actualDirect === 'horizontal') {
          result = movCallback.call(this, beginX, movX, actualDirect);
        } else {
          result = movCallback.call(this, beginY, movY, actualDirect);
        }
      }

      if (result === false) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, opts, true);

    on(elm, TOUCH_END, function (e) {
      endY = getEventPageXY(e, 'y', true);
      endX = getEventPageXY(e, 'x', true);

      if (typeof opts.direct !== 'undefined') {

        if (opts.direct === 'horizontal') {
          endCallback.call(this, beginX, endX, actualDirect);
        } else {
          endCallback.call(this, beginY, endY, actualDirect);
        }
      } else {

        if (actualDirect === 'horizontal') {
          endCallback.call(this, beginX, endX, actualDirect);
        } else {
          endCallback.call(this, beginY, endY, actualDirect);
        }
      }

    }, opts, true);

  };

/************** debug **************/

  var index = 1;
  var lastLog = '';
  var log = function () {
    var logBox = document.getElementById('logBox');

    if (logBox === null) {
      return;
    }

    var s = ([]).join.call(arguments, ',');

    if (s === lastLog) {
      index++;
      logBox.innerHTML = logBox.innerHTML.replace(/\(\d+\)$/, '(' + index + ')');
    } else {
      lastLog = s;
      index = 1;
      logBox.innerHTML = logBox.innerHTML + ' | ' + s + '(1)';
    }
  };

/************** util **************/

  var formatTime = function (time) {
    var second = Math.floor([time % 60]);
    var mintue = Math.floor(time / 60);
    second = second < 10 ? '0' + second : second;
    mintue = mintue < 10 ? '0' + mintue : mintue;
    return mintue + ':' + second;
  };

  var device = (function () {
    var ua = navigator.userAgent;
    var android = ua.match(/(Android)\s+([\d.]+)/);
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var iphone = ua.match(/(iPhone\sOS)\s([\d_]+)/);
    var wphone = ua.match(/Windows Phone/);

    if (iphone) {
      return 'iphone';
    } else if (ipad) {
      return 'ipad';
    } else if (android) {
      return 'android';
    } else if (wphone) {
      return 'wphone';
    }
    return "other";

  }());

  var cookie = {
    getByEncode: function (name) {
      var arg = name + "=";
      var alen = arg.length;
      var clen = doc.cookie.length;
      var i = 0;

      while (i < clen) {
        var j = i + alen;

        if (doc.cookie.substring(i, j) === arg) {
          return (function (offset) {
            var endstr = doc.cookie.indexOf(";", offset);

            if (endstr === -1) {
              endstr = doc.cookie.length;
            }

            return decodeURIComponent(doc.cookie.substring(offset, endstr));
          })(j);
        }

        i = doc.cookie.indexOf(" ", i) + 1;

        if (i === 0) {
          break;
        }

      }
      return "";
    },

    setByEncode: function (name, value, params) {
      var cStrArr = [];
      cStrArr.push(name + '=' + encodeURIComponent(value));

      if (typeof params === 'undefined') {
        params = {};
      }

      if (typeof params.expires !== 'undefined') {
        var date = new Date();
        date.setTime(date.getTime() + (params.expires) * 1000 * 60);
        cStrArr.push('; expires=' + date.toGMTString());
      }

      cStrArr.push((typeof params.path !== 'undefined') ? '; path=' + params.path : '');
      cStrArr.push((typeof params.domain !== 'undefined') ? '; domain=' + params.domain : '');
      cStrArr.push((typeof params.secure !== 'undefined') ? '; secure' : '');

      document.cookie = cStrArr.join('');
    }
  };

  //随机获取一个uid
  var  getRandomUid = function() {
      var date = new Date().getTime(),
          uid = '',
          fn = '',
          sn = '';

      fn = ((Math.random() * 2147483648) | 0).toString(36);
      sn = Math.round(Math.random() * 10000);
      uid = date + '_' + fn + sn;
      return uid;
  };

  module.exports = {
    append : append,
    query: query,
    hasClass: hasClass,
    addClass: addClass,
    css: css,
    removeClass: removeClass,
    on: on,
    log: log,
    tap: tap,
    swip: swip,
    controllSwip: controllSwip,
    formatTime: formatTime,
    html: html,
    device: device,
    extend: extend,
    cookie: cookie,
    getRandomUid: getRandomUid
  };



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.core.mobile.util/index.js